import type { IconSvgObject } from './types';

const TelevisionTableIcon: IconSvgObject = [
  ["path", { d: "M7 18H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 18H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["rect", { x: "3", y: "14", width: "18", height: "8", rx: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M10.5 11L10 14M13.5 11L14 14", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["rect", { x: "6", y: "2", width: "12", height: "9", rx: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M12 14V22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "5" }]
];

export default TelevisionTableIcon;
